var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28025 10.2802C7.134 10.4265 6.942 10.5 6.75 10.5C6.558 10.5 6.366 10.4265 6.21975 10.2802L3.21975 7.28025C2.9265 6.987 2.9265 6.513 3.21975 6.21975C3.513 5.9265 3.987 5.9265 4.28025 6.21975L6.75 8.6895L13.0125 2.427C11.6423 0.93825 9.68325 0 7.5 0C3.35775 0 0 3.35775 0 7.5C0 11.6423 3.35775 15 7.5 15C11.6423 15 15 11.6423 15 7.5C15 6.08625 14.6018 4.7685 13.9215 3.639L7.28025 10.2802Z",
    fill: "#08BD80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanTick);
export default __webpack_public_path__ + "static/media/plan_tick.2d179399fc39b9d6229339687f5280cb.svg";
export { ForwardRef as ReactComponent };